// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "./default/chunk-article-listed.2f23fee52b954a908e3b.js";
	if (chunkId === 39) return "./default/chunk-subscription.12902398e531d8e5ab8f.js";
	if (chunkId === 68) return "./68.f14e3e503b758670201b.js";
	if (chunkId === 37) return "./default/chunk-small-gallery.f202139071b547460308.js";
	if (chunkId === 33) return "./default/chunk-photo-credit-toogle.a5e2d01ca94b791c2fda.js";
	if (chunkId === 38) return "./default/chunk-social-click.e48cc4cc8a3d996ec4bb.js";
	if (chunkId === 41) return "./default/chunk-table.ec05bcc169bc5b02bf5f.js";
	if (chunkId === 45) return "./default/gallery-in-art-preserve-scroll.0a511e41a0db23d47f71.js";
	if (chunkId === 69) return "./69.135fd8d4824b87cf2cc7.js";
	if (chunkId === 32) return "./default/chunk-online-reports.de4b17b043532c38ee92.js";
	if (chunkId === 6) return "./chunk-league-table.1d8385991013c5b197c8.js";
	// return url for filenames based on template
	return undefined;
};